var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getSelectedPages.length == 1 && _vm.loadingStatus.data)?_c('Dash-posts-stats-one'):_vm._e(),(_vm.getSelectedPages.length > 1 && _vm.loadingStatus.data)?_c('Dash-posts-stats-many'):_vm._e(),_c('scroll-loader',{staticClass:"dash-loader",attrs:{"loader-method":()=> {},"loader-enable":!_vm.loadingStatus.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }